<template lang="">
    <div v-if="steps" class="flex caret-transparent">
        <div class="flex gap-x-6 relative">
            <label v-for="step in steps" :key="step" 
                class="h-8 w-8 rounded-full border-2 bg-white border-gray-500 text-gray-500 text-xl flex justify-center items-center z-10"
                :class="{
                    'bg-primary border-primary text-white' : step === value,
                    'cursor-pointer' : isStepEnabled(step)
                }"
            >
                <span>{{step}}</span>
                <input type="radio" :value="step" v-model="value" :disabled="!isStepEnabled(step)" class="hidden">
            </label>
            <hr class="border-gray-500 border-dashed w-full absolute top-1/2"/>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        enabledSteps: Number,
        steps: Number,
        modelValue: Number,
    },

    emits: ['update:modelValue'],

    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },

    methods: {
        isStepEnabled(step) {
            return !this.enabledSteps || step <= this.enabledSteps
        }
    }
}
</script>